module.exports = __webpack_public_path__ + "media/60.41afa643.mp3";